export default __webpack_public_path__ + "static/media/decayingwindow.6ab64d22.png";